export enum AgentSkillCategory {
    BOOKKEEPING = "bookkeeping",
    TAX = "tax",
    COMMUNICATIONS = "communications",
    CLOSE = "close",
    OTHER = "other",
}

export enum AgentSkillLoadMode {
    ALWAYS = "always",
    ON_DEMAND = "on_demand",
}

export enum AgentSkillKind {
    KICK = "kick",
    FIRM = "firm",
}

export interface FirmSkillRevisionIds {
    always: string[];
    onDemand: string[];
    kick: string[];
}
